module.exports = __webpack_public_path__ + "static/media/160509_MarketingScrum_Mobile.034.786b9392.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/160509_MarketingScrum_Mobile/160509_MarketingScrum_Mobile.034.png
// module id = 292
// module chunks = 0